// src/components/Projects.js
import React from 'react';
import './Projects.css'; // Optional for custom styles

function Projects() {
  const projectList = [
    {
      title: 'Project 1',
      description: 'Description of project 1.',
      link: '#',
      image: 'path/to/image1.jpg'
    },
    {
      title: 'Project 2',
      description: 'Description of project 2.',
      link: '#',
      image: 'path/to/image2.jpg'
    }
  ];

  return (
    <section className="projects">
      <h2>My Projects</h2>
      <div className="project-cards">
        {projectList.map((project, index) => (
          <div key={index} className="project-card">
            <img src={project.image} alt={project.title} />
            <h3>{project.title}</h3>
            <p>{project.description}</p>
            <a href={project.link} className="project-link">View Project</a>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Projects;
